export type IRemoveLastCharacterOf = (s: string, character: string) => string;

export function removeLastCharacterOf(s: string, character: string): string {
  let str = s;
  if (str.substring(str.length - 1) === character) {
    str = str.substring(0, str.length - 1);
  }
  return str;
}
